var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPipe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#00A0AE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1666 24.75C38.1666 23.6597 38.1666 23.1145 37.9321 22.7084C37.7785 22.4423 37.5576 22.2214 37.2916 22.0678C36.8855 21.8334 36.3403 21.8334 35.2499 21.8334L30.8749 21.8334L30.8749 18.3334C30.8749 17.8501 30.4832 17.4584 29.9999 17.4584C29.5167 17.4584 29.1249 17.8501 29.1249 18.3334L29.1249 21.8334L24.7499 21.8334C23.6595 21.8334 23.1143 21.8334 22.7083 22.0678C22.4422 22.2214 22.2213 22.4423 22.0677 22.7084C21.8333 23.1145 21.8333 23.6597 21.8333 24.75C21.8333 25.8404 21.8333 26.3856 22.0677 26.7917C22.2213 27.0577 22.4422 27.2787 22.7083 27.4323C23.1143 27.6667 23.6595 27.6667 24.7499 27.6667H29.1249L29.1249 32.3334H27.0833C25.9929 32.3334 25.4477 32.3334 25.0416 32.5678C24.7756 32.7214 24.5546 32.9423 24.401 33.2084C24.1666 33.6145 24.1666 34.1597 24.1666 35.25C24.1666 36.3404 24.1666 36.8856 24.401 37.2917C24.5546 37.5577 24.7756 37.7787 25.0416 37.9323C25.4477 38.1667 25.9929 38.1667 27.0833 38.1667H29.1249L29.1249 41.6667C29.1249 42.15 29.5167 42.5417 29.9999 42.5417C30.4832 42.5417 30.8749 42.15 30.8749 41.6667L30.8749 38.1667H32.9166C34.007 38.1667 34.5522 38.1667 34.9583 37.9323C35.2243 37.7787 35.4452 37.5577 35.5988 37.2917C35.8333 36.8856 35.8333 36.3404 35.8333 35.25C35.8333 34.1597 35.8333 33.6145 35.5988 33.2084C35.4452 32.9423 35.2243 32.7214 34.9583 32.5678C34.5522 32.3334 34.007 32.3334 32.9166 32.3334H30.8749V27.6667H35.2499C36.3403 27.6667 36.8855 27.6667 37.2916 27.4323C37.5576 27.2787 37.7785 27.0577 37.9321 26.7917C38.1666 26.3856 38.1666 25.8404 38.1666 24.75Z",
    fill: "#EEE82C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#CCECEF",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipe);
export default __webpack_public_path__ + "static/media/pipe.4f74d2a2db779e214c8e338d2700377a.svg";
export { ForwardRef as ReactComponent };